import {useNavigate, useSearchParams} from "react-router-dom";
import {directusContext} from "../../app/DirectusProvider";
import {useContext, useState} from "react";
import {useJwt} from "react-jwt";
import {toast} from "react-toastify";
import AuthForm from "../common/AuthForm";

const AcceptInvitation = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const {directus, updateVersion, setCurrentUser} = useContext(directusContext);

    const token = searchParams.get("token");
    const {decodedToken, isExpired} = useJwt(token);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    let validInvitation = true;

    if (!token) {
        validInvitation = false;
        toast.error("Lien d'invitation invalide.");
    } else if (isExpired) {
        validInvitation = false;
        toast.error("Lien d'invitation expiré. Veuillez contacter un responsable.");
    }

    const acceptInvitation = (e) => {
        e.preventDefault();
        let invalidPassword = false;
        if (password.length < 8) {
            toast.error("Le mot de passe doit faire au minimum 8 caractères!");
            invalidPassword = true;
        } else if (password !== confirmPassword) {
            invalidPassword = true;
            toast.error("Les mots de passe ne correspondent pas!");
        }

        if (!invalidPassword) {
            directus.users.invites.accept(token, password).then(() => {
                toast.success("Validation réussie.");
                directus.auth.login({email: decodedToken.email, password: password}).then(() => {
                    directus.users.me.read({fields: ["*", "role.*"]}).then(resp => {
                        setCurrentUser(resp);
                        updateVersion();
                        navigate("/cours");
                    });
                });
            }).catch(() => {
                toast.error("Erreur lors de la validation. Si le problème persite, veuillez contacter votre administrateur.");
            });
        }
    };

    return (
        <AuthForm
            handleSubmit={acceptInvitation}
            buttonText="Valider"
            input1={{
                id: "password",
                type: "password",
                label: "Mot de passe",
                placeholder: "********",
                disabled: !validInvitation,
                value: password,
                onChange: (e) => setPassword(e.target.value)
            }}
            input2={{
                id: "confirmPassword",
                type: "password",
                label: "Confirmer le mot de passe",
                placeholder: "********",
                disabled: !validInvitation,
                value: confirmPassword,
                onChange: (e) => setConfirmPassword(e.target.value)
            }}/>
    )
}

export default AcceptInvitation;
